export default (productId: string) => {
  const { enableColorAsAttribute } = useAppConfig().pages.pdp
  const { dialogOptions: { type: dialogType } } = useAppConfig().components.dialog.default
  const route = useRoute()

  /**
   * Replaces the productId in the given value with a formatted product link.
   * @param value - The string containing the productId.
   * @returns The formatted string with the product link.
   */
  const formatBarcodeText = (value: string) => {
    const color = route.query?.color?.toString()
    const id = enableColorAsAttribute && color && value.includes(color)
      ? `${productId}${color}`
      : productId
    return value.replace(id, `{product-link|${id}}`)
  }

  /**
   * Generates a barcode dialog link for the given id.
   * @returns The dialog link string for the barcode.
   */
  const getBarcodeLink = () => `#${dialogType}=barcode_${productId}`

  return {
    formatBarcodeText,
    getBarcodeLink
  }
}
